import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Scrollbars } from "react-custom-scrollbars";

import "./MyHistoryListing.scss";
import CaloriesBurned from "./caloriesBurned";
import FilterHistory from "./filterHistory";
import ReactStackedBarChart from "../../../sharedComponents/reactStackedBarChart";
import Tooltip from "../../../sharedComponents/tooltip";
import { getMyHistoryGraph } from "../../../store/actions";
import { objToQueryString } from "../../../utils/common";

export const MyHistory = ({ myHistoryGraphList, getMyHistoryGraph }) => {
	useEffect(() => {
		getMyHistoryGraph();
	}, [getMyHistoryGraph])

	const [toggleFilterHistoryPanel, setToggleFilterHistoryPanel] = useState(false);

	const applyFilter = (values) => {
		setToggleFilterHistoryPanel(false);
		const queryString = objToQueryString(values);
		getMyHistoryGraph(queryString);
	};

	return (
		<section className="page page-history-list">
			<div className="container">
				<div className="d-flex flex-row justify-content-between mb-2">
					<h3>My History</h3>
					<Tooltip content="Filter">
						<button
							className="btn btn-primary-dark btn-ghost btn-icon"
							onClick={() => setToggleFilterHistoryPanel(true)}>
							<i className="icon icon-filter " />
						</button>
					</Tooltip>
				</div>

				<div className="block block-primary p-4">
					<div className="d-flex">
						{myHistoryGraphList && myHistoryGraphList.chart_title ? (
							<div className="flex-fill">
								<div>
									<h4 className="text-primary-dark mb-3">{myHistoryGraphList.chart_title}</h4>
									<ReactStackedBarChart
										data={{
											data_categories: myHistoryGraphList.data_categories,
											data_series: myHistoryGraphList.data_series
										}}
										fill={false}
										height={36}
									/>
								</div>
							</div>
						) : null}
						<div className="legends-container">
							<Scrollbars className="wrapper-scrollbar">
								{myHistoryGraphList &&
									myHistoryGraphList.data_series &&
									myHistoryGraphList.data_series.map((item, index) => {
										return (
											<p className="mb-1" key={index}>
												<span className="pr-2" style={{ color: item.color }}>
													&bull;
												</span>
												{item.name}
											</p>
										);
									})}
							</Scrollbars>
						</div>
					</div>
				</div>
				<CaloriesBurned />
				<FilterHistory show={toggleFilterHistoryPanel} onSubmit={applyFilter} update={setToggleFilterHistoryPanel} />
			</div>
		</section>
	);
};

const mapDispatchToProps = { getMyHistoryGraph };

const mapStateToProps = (state) => {
	const { MyProgress } = state;
	return {
		myHistoryGraphList: get(MyProgress, "myHistoryGraphResult", [])
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MyHistory);
